import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class GetAdminSearchDemandArgs {
  /** Hide terms searched fewer times than this. */
  @Field(type => Int, { nullable: true })
  minSearches?: number

  @Field(type => Int, { nullable: true })
  skip?: number

  @Field(type => Int, { nullable: true })
  take?: number

  /** ratio (the default), searchCount, resultCount or term; anything else sorts by ratio. */
  @Field({ nullable: true })
  sortBy?: string

  @Field(type => Boolean, { nullable: true })
  descending?: boolean
}
